import {
	SET_USER_ID_EMAIL_MAP,
	SET_PERMISSION,
	SET_ACTIVE_PERMISSION,
	GET_PERMISSIONS,
	EDIT_PERMISSION,
	REMOVE_PERMISSION
} from './types';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const defaultState = {
	loading: false,
	userIdEmailMap: false,
	permissions: [],
	activePermission: {}
}

export const adminsReducer = ( state = defaultState, action ) => {

	switch( action.type ){
		
		case SET_USER_ID_EMAIL_MAP:
			return {
				...state,
				userIdEmailMap: action.userIdEmailMap
			}

		case SET_ACTIVE_PERMISSION:
			return {
				...state,
				activePermission: action.permission
			}

		case `${EDIT_PERMISSION}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${EDIT_PERMISSION}_${FULFILLED}`:
			
			return {
				...state,
				loading: false,
				permissions:state.permissions.map( _permission => {
					
					if( _permission._id == action.payload.data.permission._id ){
						return action.payload.data.permission
					}
					
					return _permission
				})
			}
	
		case `${EDIT_PERMISSION}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${REMOVE_PERMISSION}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${REMOVE_PERMISSION}_${FULFILLED}`:
			
			return {
				...state,
				loading: false,
				permissions: state.permissions.filter( _permission => {
					return _permission._id != action.payload.data.permissionId
				})
			}
	
		case `${REMOVE_PERMISSION}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${SET_PERMISSION}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${SET_PERMISSION}_${FULFILLED}`:
			
			return {
				...state,
				loading: false,
				permissions:[
					...state.permissions,
					action.payload.data.permission
				]
			}
	
		case `${SET_PERMISSION}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		case `${GET_PERMISSIONS}_${PENDING}`:
			return {
				...state,
				loading: true
			}

		case `${GET_PERMISSIONS}_${FULFILLED}`:
			return {
				...state,
				loading: false,
				permissions:action.payload.data.permissions
			}
	
		case `${GET_PERMISSIONS}_${REJECTED}`:
			return {
				...state,
				loading: false,
			}

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/admin/reducers.js